import { Box, Container } from "@mui/material";
import Header from "components/header/Header";
import { MediumLargeText } from "components/typography";

export default function OrderTaken(){
  return(
    <Container sx={{ pl: { lg: 12, md: 12, xs: 12 }, pt: 5 }}>
      <Header header="Bestellung nicht erfolgreich" />
      <Box sx={{display: "flex", flexDirection:"column", pt: 5, gap: 1}}>
        <MediumLargeText>In Ihrer Bestellung ist ein Los, dass leider schon verkauft wurde.</MediumLargeText>
      </Box>
    </Container>
  )
}